<!--
Author: TangChen
Date: 2019-02-25
Desc: 绘制组合基金自选表格，为公共组件
-->
<template>
    <div class="comp-combo-general comp">
        <el-table :data="combo" class="tab-list-tit" style="width: 100%">
            <el-table-column label="基金名称">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.fundcode" v-on:change="newCombo">
                        <el-option
                            v-for="item in fundArr"
                            :key="item.fundcode"
                            :label="item.fundname + '(' + item.fundcode + ')'"
                            :value="item.fundcode"
                            :disabled="
                                item.fundcode !== scope.row.fundcode &&
                                hasSel.indexOf(item.fundcode) > -1
                            "
                        >
                            {{ item.fundname + "(" + item.fundcode + ")" }}
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="收费方式" width="200" align="center">
                <template slot-scope="scope">
                    <div>
                        {{
                            scope.row.sharetype
                                ? $cache.getDict("130000", scope.row.sharetype)
                                : "未知"
                        }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="组合比例" width="240">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.comRate" v-on:change="newCombo">
                        <el-option
                            v-for="item in $cache.getDict('110247')"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        size="small"
                        class="combo-del"
                        :class="{ lock: combo.length === 2 }"
                        :disabled="combo.length < 3"
                        v-on:click.prevent="del(scope.row.fundcode)"
                    >
                        <i class="el-icon-delete" aria-hidden="true" />
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="combo-msg">
            <div class="combo-all" :class="{ warning: all !== 100 }">
                <i class="el-icon-info" aria-hidden="true" />
                组合比例：{{ all }}%
                <span>(必须为100%)，最多可选5支基金</span>
            </div>
            <el-button
                class="add-combo"
                :type="combo.length === 5 || combo.length === fundArr.length ? 'lock' : 'text'"
                :disabled="combo.length === 5 || combo.length === fundArr.length"
                v-on:click.prevent="add"
            >
                <i class="el-icon-circle-plus-outline" aria-hidden="true" />
                添加基金
            </el-button>
        </div>
        <div class="confirm-btn">
            <el-button
                :type="all !== 100 || $util.isPersonalBuyBusinessDisabled() ? 'lock' : 'yellow'"
                :class="{ 'is-disabled': $util.isPersonalBuyBusinessDisabled() }"
                :disabled="all !== 100"
                v-on:click.prevent="confirmFund"
            >
                确认组合基金
            </el-button>
            <el-button v-on:click.prevent="$router.back()">返回</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: "ComboGeneral",
    props: {
        flag: {
            type: String,
            default: "2"
        }
    },
    data() {
        return {
            fundList: [],
            fundArr: [],
            combo: [],
            hasSel: "", // 已选中基金
            all: 0 // 组合比例之和
        };
    },
    watch: {
        fundList() {
            this.getComboFund();
        }
    },
    mounted() {},
    methods: {
        // 查询能定投基金信息
        getComboFund() {
            const _x = this.fundList;
            this.combo = [];
            if (this.fundList.length < 2) {
                this.$confirm(
                    "目前系统支持的自选组合基金数量不足，不能自选组合基金",
                    "自选组合基金信息提示",
                    {
                        confirmButtonText: "我的资产",
                        cancelButtonText: "返回",
                        type: "warning",
                        customClass: "info-check"
                    }
                )
                    .then((action) => {
                        if (action === "confirm") {
                            this.$router.push({ name: "home" });
                        }
                    })
                    .catch(() => {
                        this.$router.back();
                    });
                return false;
            }
            for (let i in _x) {
                let _y = Object.assign({}, _x[i], {
                    comRate: i === "0" ? "10" : "90",
                    group: "1"
                });
                // 存入组合定投基金信息
                this.combo.push(_y);
                if (i === "1") {
                    break;
                }
            }
            this.newCombo();
            this.fundArr = _x;
        },
        // 新增定投基金
        add() {
            const _this = this;
            const _y = this.fundArr.filter((item) => {
                return _this.hasSel.indexOf(item.fundcode) === -1;
            })[0];
            _y.group = "1";
            // 新增基金信息
            this.$set(
                this.combo,
                this.combo.length,
                Object.assign({}, _y, {
                    comRate: this.all < 100 ? (100 - this.all).toString() : "10"
                })
            );
            this.newCombo();
        },
        // 删除定投基金
        del(code) {
            this.combo = this.combo.filter((item) => {
                return item.fundcode !== code;
            });
            // 删除基金后组合比例数据更新
            if (this.combo.length === 2) {
                this.$set(
                    this.combo[this.combo.length - 1],
                    "comRate",
                    (100 - Number(this.combo[0].comRate)).toString()
                );
            }
            this.newCombo();
        },
        // 修改组合定投基金，更新选中数据
        newCombo() {
            this.hasSel = "";
            this.all = 0;
            for (let i in this.combo) {
                this.hasSel += this.combo[i].fundcode + ",";
                this.all += Number(this.combo[i].comRate);
            }
        },
        // 组合基金
        confirmFund() {
            if (this.$util.checkPersonalBuyBusinessDisabled(this.flag === "1" ? "定投" : "申购")) {
                return;
            }
            let _z = [];
            for (let i in this.combo) {
                const _y = Object.assign({}, this.combo[i]);
                _y.comrate = (_y.comRate / 100).toFixed(2);
                _z.push(_y);
            }
            const _x = this.$util.getCodeOnly(
                _z,
                {
                    code: "group",
                    data: [
                        "tano",
                        "fundcode",
                        "fundname",
                        "comrate",
                        "risklevel",
                        "sharetype",
                        "investkind",
                        "investterm"
                    ]
                },
                ","
            );
            const _y = this.$util.getObjParam(
                _x[0],
                "tano,fundcode,fundname,comrate,sharetype,investkind,investterm"
            );
            this.$emit("combo-list", _y);
        }
    }
};
</script>
<style lang="scss">
.comp-combo-general {
    .el-table th {
        background-color: $bg5;
    }
    .el-table td div {
        width: 100%;
    }
    .combo-del.el-button--text {
        &.lock {
            color: $text-color3;
        }
        color: $color-b;
        font-size: $f16;
        i {
            margin-right: 2px;
            font-size: $f18;
        }
    }
    .el-table {
        margin-bottom: 0;
        .cell {
            padding-left: 20px;
            padding-right: 20px;
        }
    }
    .combo-msg {
        position: relative;
        text-align: right;
        padding: 15px 20px;
        .combo-all {
            position: absolute;
            left: 20px;
            top: 15px;
            line-height: 36px;
            color: var(--color-primary);
            &.warning {
                color: $color-c;
            }
            i {
                margin-right: 4px;
            }
            span {
                color: $text-color3;
            }
        }
        .add-combo {
            padding: 7px 20px;
            span {
                display: inline-block;
                color: $color-b;
                height: 20px;
                line-height: 20px;
                font-size: $f16;
            }
            i {
                margin-right: 4px;
                font-size: $f20;
                font-weight: bold;
                vertical-align: middle;
            }
            &.el-button--lock {
                span {
                    color: $text-color3;
                }
            }
        }
        .el-button--blue,
        .el-button--lock {
            span {
                display: inline-block;
            }
            i {
                margin-right: 2px;
            }
        }
    }
    .confirm-btn {
        text-align: center;
        margin: 0 0 40px;
        .el-button + .el-button {
            margin-left: 20px;
        }
    }
}
</style>
